import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { DeferRenderingModule } from 'app/shared/directives/defer-rendering/defer-rendering.module';
import { ButtonModule } from '../../../button/button.module';
import { ListModule } from '../../../list/list.module';
import { LoadingPanelModule } from '../../../loading-panel/loading-panel.module';
import { TreeListModule } from '../../../tree-list/tree-list.module';
import { BufferFormModule } from '../buffer-form/buffer-form.module';
import { HighlightConfigFormModule } from '../highlight-config-form/highlight-config-form.module';
import { AttachmentsModule } from './components/attachments/attachments.module';
import { IdentifyComponent } from './identify.component';
import { PipesModule } from 'app/shared/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    TreeListModule,
    ListModule,
    ButtonModule,
    LoadingPanelModule,
    BlockModalDragModule,
    AttachmentsModule,
    BufferFormModule,
    HighlightConfigFormModule,
    PipesModule
  ],
  declarations: [IdentifyComponent],
  exports: [IdentifyComponent],
})
export class IdentifyModule { }
